// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as V2f$Linear from "./V2f.res.js";
import * as Stdlib_Result from "@rescript/runtime/lib/es6/Stdlib_Result.js";

function asV2f(v2) {
  return v2._0;
}

function normalize(v2) {
  return {
    TAG: "N2",
    _0: V2f$Linear.scaleTo(v2, 1)
  };
}

function map(v2, f) {
  let v2$1 = f(v2._0);
  return {
    TAG: "N2",
    _0: V2f$Linear.scaleTo(v2$1, 1)
  };
}

let jsonCodec = Jzon.custom(n2 => Jzon.encodeWith(n2._0, V2f$Linear.jsonCodec), json => Stdlib_Result.map(Jzon.decodeWith(json, V2f$Linear.jsonCodec), normalize));

export {
  asV2f,
  normalize,
  map,
  jsonCodec,
}
/* jsonCodec Not a pure module */
